import { CSS_PROPS } from 'common/constants';

/**
 * List of supported css properties, divided into conditional groups
 */
export const cssProps = CSS_PROPS;
